import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'mydocma-mm-fields-attribute-dropdown-tile',
  templateUrl: './fields-attribute-dropdown-tile.component.html',
  styleUrls: ['./fields-attribute-dropdown-tile.component.scss']
})
export class FieldsAttributeDropdownTileComponent {
  private itemInternal: any;
  imageUrl: SafeUrl;

  constructor(private sanitizer: DomSanitizer) {}

  @Input()
  public set item(value: any) {
    this.itemInternal = value;
    
    if (this.itemInternal?.data?.buffer) {
      const url = this.sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(new Blob([this.itemInternal.data.buffer]))
      );
      this.imageUrl = url;
    } else {
      this.imageUrl = null;
    }
  }

  public get item(): any {
    return this.itemInternal;
  }
}